import * as R from 'ramda';

import { SchemaTree, SelectedAttributeRoute } from '@atom/types/schema';

export const getAttributePathFromRoute = (
  subItem: Partial<SchemaTree>,
  route: SelectedAttributeRoute,
): any[] => {
  const groupIndex = R.findIndex(R.propEq(route.attributeGroupId, 'id'))(
    subItem?.attributeGroups || [],
  );

  const group = subItem.attributeGroups[groupIndex];

  const attributeIndex = R.findIndex(R.propEq(route.attributeId, 'id'))(
    group?.attributes || [],
  );

  return ['attributeGroups', groupIndex, 'attributes', attributeIndex];
};
